import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Shield, Check } from 'lucide-react';

/** Split sign-in layout shared by the signed-out account pages. */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <main id="main-content">
      <div className="auth-layout">
        <aside className="auth-aside">
          <Link to="/" className="brand-lockup od-row">
            <span className="brand-symbol"><Shield className="od-icon" /></span>
            <span>AirGap<span className="brand-suite"> Suite</span></span>
          </Link>
          <div className="auth-aside-copy">
            <p className="auth-eyebrow">License operations, connected</p>
            <h2>Control access.<br />Keep working.</h2>
            <p>From the first license to the last offline verification, keep the decisions and records in one place.</p>
            <ul>
              <li><Check className="od-icon" />Policy-based entitlements</li>
              <li><Check className="od-icon" />Hardware-bound activation</li>
              <li><Check className="od-icon" />Offline verification packages</li>
            </ul>
          </div>
          <p className="auth-aside-foot">AirGap Suite / Workspace access</p>
        </aside>
        <div className="auth-form-region">
          <div className="auth-form-wrap">{children}</div>
        </div>
      </div>
    </main>
  );
}
